import { Component, input, output } from '@angular/core';


@Component({
    selector: 'ui-select-box-option',
    host: {
        'animate.enter': 'fade-enter',
        'animate.leave': 'fade-leave',
        'style': '--fade-duration: 0.2s',
        'class': 'btn btn-secondary',
        '[class.flex-grow-1]': 'text().includes("\\n")',
    },
    styles: [
        `
        :host {
            display: flex;
            white-space: normal;
            word-break: break-word;
            pointer-events: none;
            margin: 0;
            padding: 3px 5px;
            border-radius: 2px;
        }
        .remove {
            pointer-events: auto;
            border: none;
            background: none;
            outline: none;
            opacity: 0;
            cursor: pointer;
            align-self: flex-start;
            padding: 0 .3em;
            transition: .35s;
        }
        .remove:active,
        .remove:hover {
            opacity: 1;
        }
        .text {
            white-space: break-spaces;
            flex-grow: 1;
        }
        `,
    ],
    template: `
        <span class="text">
            {{ text() }}
        </span>
        <button type="button" tabindex="-1" class="remove" (click)="onRemove($event)">
            &times;
        </button>
    `,
})
export class SelectBoxOptionComponent {

    text = input.required<string>();

    remove = output<void>();

    onRemove(event: Event) {
        event.stopImmediatePropagation();
        this.remove.emit();
    }
}
